import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import * as styles from './styles/styles.module.scss';
import NoSsr from '@material-ui/core/NoSsr';

const Checkbox = props => {
  return (
    <NoSsr fallback={<div className={styles.ssrSpacer} />}>
      <FormControlLabel
        classes={{ label: styles.label, root: props.labelClassName }}
        control={
          <MaterialCheckbox
            classes={{ root: styles.checkboxRoot, checked: styles.checked }}
            checked={props.checked}
            disableRipple
            disabled={props.disabled}
            onChange={props.handleChange}
            size="small"
            name={props.name}
          />
        }
        label={props.label}
      />
    </NoSsr>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool
};

Checkbox.defaultProps = {
  checked: false,
  handleChange: () => {},
  name: '',
  label: 'Checkbox label',
  disabled: false
};

export default Checkbox;
